import styled from 'styled-components';
import { format, parseISO } from 'date-fns';
import { observer } from 'mobx-react-lite';
import { useStore } from 'models/stores';

import Heading from './Heading';

function JobHeader({ job, langData: data, showDeadline = false }) {
  const {
    uiStore: { t, language },
  } = useStore();
  const hasStatus = job.status && job.status !== 'not_specified';
  const statusStr = hasStatus && t(`jobStatus_${job.status}`);
  const fmt = language === 'en' ? 'MMMM d, yyyy' : 'dd.MM.yyyy';
  let subtitle = job.locationDisplay;
  if (hasStatus) {
    subtitle += ` - ${statusStr}`;
  }
  return (
    <>
      <Heading>{data.title}</Heading>
      <JobListingSubtitle>{subtitle}</JobListingSubtitle>
      {showDeadline && job.deadline && (
        <JobListingSubtitle>
          {t('deadline_display')}: {format(parseISO(job.deadline), fmt)}
        </JobListingSubtitle>
      )}
    </>
  );
}
export default observer(JobHeader);

export const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const JobListingSubtitle = styled.div`
  font-family: ${(p) => p.theme.fontFamily};
  color: ${(p) => p.theme.subHeadingColor};
  font-weight: 300;
  font-size: 14px;
`;
